import React from 'react'
import { Button } from '@chakra-ui/react'

const AddButton: React.FC<React.PropsWithChildren<{ disabled: boolean; onClick: () => void }>> = ({
  onClick,
  disabled
}) => {
  return (
    <Button disabled={disabled} colorScheme='teal' size='xs' onClick={onClick}>
      Add +
    </Button>
  )
}

export default AddButton
